<template>
  <span :class="wrpClasses" @click="toggle">
    <input type="hidden" :name="name" :value="currentValue">
  </span>
</template>

<script>
import { oneOf } from '../../utils/assist'
const prefixCls = 'bcc-switch'

export default {
  name: 'BccSwitch',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    name: {
      type: String
    },
    size: {
      validator (value) {
        return oneOf(value, ['large', 'small', 'default'])
      },
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    wrpClasses () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-checked`]: this.currentValue === this.trueValue,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-loading`]: this.loading
        }
      ]
    }
  },
  methods: {
    toggle (e) {
      e.preventDefault()
      if (this.disabled || this.loading) {
        return false
      }

      const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue
      this.currentValue = checked
      this.$emit('input', checked)
      this.$emit('on-change', checked)
    }
  }
}
</script>
